import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');

  const setDetailTitle = useCallback((title) => {
    setPageTitle(title || '');
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ pageTitle, setDetailTitle }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) return { pageTitle: '', setDetailTitle: () => {} };
  return context;
};
